import { styled } from "@mui/material/styles";
import { Box, Drawer } from "@mui/material";
import { motion } from "framer-motion";

export const drawerWidth = 240;

export const Root = styled(Box)(({ theme }) => ({
    display: "flex",
    height: "100vh",
    width: "100%",
    margin: 0,
    padding: 0,
    overflowX: "hidden",
}));

export const StyledDrawer = styled(Drawer)<{ open: boolean }>(({ theme, open }) => ({
    flexShrink: 0,
    "& .MuiDrawer-paper": {
        width: open ? drawerWidth : 0,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: "hidden",
        border: "none",
    },
}));


export const AnimatedContent = styled(motion.div)<{ open: boolean }>(({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(0),
    marginLeft: open ? drawerWidth : 0,
    transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));